import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * @file
 * @author dailin01
 */
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import classNames from 'classnames';
import { SubMenu as RcSubMenu } from './rc-menu';
import MenuContext from './MenuContext';
import { isValidElement, cloneElement } from '../_util/reactNode';
import { MenuContext as BaseMenuContext } from './rc-menu/context/MenuContext';
var SubMenu = function SubMenu(props) {
  var _a;
  var popupClassName = props.popupClassName,
    title = props.title,
    icon = props.icon,
    rest = __rest(props, ["popupClassName", "title", "icon"]);
  var contextValue = useContext(MenuContext);
  var baseMenuContextValue = useContext(BaseMenuContext);
  var inlineCollapsed = baseMenuContextValue.inlineCollapsed;
  var menuMode = contextValue.menuMode,
    prefixCls = contextValue.prefixCls;
  var titleNode;
  if (!icon) {
    titleNode = /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-title-content")
    }, inlineCollapsed && typeof title === 'string' ? title.charAt(0) : title);
  } else {
    // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
    var titleIsSpan = isValidElement(title) && title.type === 'span';
    titleNode = /*#__PURE__*/React.createElement(React.Fragment, null, cloneElement(icon, {
      className: classNames(isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(prefixCls, "-item-icon"))
    }), titleIsSpan ? title : /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-title-content")
    }, title));
  }
  return /*#__PURE__*/React.createElement(MenuContext.Provider, {
    value: _extends(_extends({}, contextValue), {
      firstLevel: false
    })
  }, /*#__PURE__*/React.createElement(RcSubMenu, _extends({
    popupClassName: classNames("".concat(prefixCls, "-").concat(menuMode, "-mode"), popupClassName),
    className: classNames(_defineProperty({}, "".concat(prefixCls, "-submenu-with-icon"), icon)),
    title: titleNode,
    preTitle: title
  }, rest)));
};
export default SubMenu;